<template>
  <Wrapper
    v-show="
      !preview && renderTools && 
      !['reheight_grid', 'remargin_grid'].includes(mode) &&
      cellActive.id
    "
    :position="cellActive.position"
    id="cell-active-frame"
    :class="{'top': !isOverScroll, 'bottom': isOverScroll}"
    :isActiveWidget="!!widgetActive.id || (detectDevice == 'mobile' && !isEnableMobile)"
  >
    <Legend class="lbl-name" :class="{'disabled': widgetActive.id || (detectDevice == 'mobile' && !isEnableMobile), 'lbl-hover': widgetActive.id}" :indexCell="indexCell" :isOverlapSection="isOverlap" @click="widgetActive.id && goTo('cell')">
      {{ $t('engine.floatframeTool.floatframeActive.cell.lblCell', languageEngine) }}
    </Legend>

    <CellTool class="d-flex cell-tool" v-if="detectDevice == 'mobile' && !widgetActive.id" :class="{'disabled': !isEnableMobile}" >
      <CellAction @click.stop.prevent="moveCellUp"
        v-show="layoutGridMobile == '01' && indexCell !== 0"
        style="width: 100%; height: 14px; padding-right: 3px;"
        v-b-tooltip.hover
        :title="$t('engine.floatframeTool.floatframeActive.cell.miniBtn.btnUpCellMobile', languageEngine)"
      >
          <i class="fas fa-sort-up" style="transform: translateY(3px);"></i>
      </CellAction>
      <CellAction @click.stop.prevent="moveCellDown"
        v-show="layoutGridMobile == '01' && gridActive.id && indexCell !== components[gridActive.id].componentsID.length - 1"
        style="width: 100%; height: 14px;"
        v-b-tooltip.hover
        :title="$t('engine.floatframeTool.floatframeActive.cell.miniBtn.btnDownCellMobile', languageEngine)"
      >
        <i style="transform: translateY(-5px)" class="fas fa-sort-down"></i>
      </CellAction>
      <CellAction @click.stop.prevent="moveCellUp" style="transform: rotate(-90deg); height: 14px; padding-top: 2px;"
        v-show="layoutGridMobile != '01' && indexCell !== 0"
        v-b-tooltip.hover
        :title="$t('engine.floatframeTool.floatframeActive.cell.miniBtn.btnBackCellMobile', languageEngine)"
      >
        <i class="fas fa-sort-up"></i>
      </CellAction>
      <CellAction @click.stop.prevent="moveCellDown" style="transform: rotate(-90deg); height: 14px; padding-top: 2px;"
        v-show="layoutGridMobile != '01' && gridActive.id && indexCell !== components[gridActive.id].componentsID.length - 1"
        v-b-tooltip.hover
        :title="$t('engine.floatframeTool.floatframeActive.cell.miniBtn.btnNextCellMobile', languageEngine)"
      >
        <i style="transform: translateY(-5px)" class="fas fa-sort-down"></i>
      </CellAction>
      <CellAction @click.stop.prevent="toggleEnableMobile" style="width: 100%; height: 14px;">
        <span v-show="isEnableMobile"
          v-b-tooltip.hover
          :title="$t('engine.floatframeTool.floatframeActive.cell.miniBtn.btnHiddenOnMobile', languageEngine)"
        >
          <i
            style="font-size: 10px; transform: translateY(-8px);"
            class="far fa-eye-slash"
          ></i
        ></span>
        <span v-show="!isEnableMobile"
          v-b-tooltip.hover
          :title="$t('engine.floatframeTool.floatframeActive.cell.miniBtn.btnShowCell', languageEngine)"
        >
          <i
            style="font-size: 10px; transform: translateY(-7px);"
            class="far fa-eye"
          ></i
        ></span>
      </CellAction>
    </CellTool>
    <Reheight v-if="isShowRehigh && !widgetActive.id" :component_id="cellActive.id" />
    <RePadding v-if="!widgetActive.id && detectDevice == 'desktop'" :component_id="cellActive.id" />
    <div @click.stop.self.prevent v-if="!widgetActive.id"></div>
  </Wrapper>
</template>

<script>
import Reheight from "./Reheight";
import RePadding from "./RePadding.vue";
import { mapGetters } from "vuex";
import { Wrapper, Legend, CellTool, CellAction } from "./CellActive.styled";
import { SECTION_TYPE_NONE_SETTING } from "@model/components/componentMeta.model";
import gridLayoutConfig from "@model/layoutConfigs/grid";

export default {
  components: {
    Wrapper,
    Legend,
    Reheight,
    RePadding,
    CellTool,
    CellAction,
  },

  data() {
    return {
      resizePaddingActive: undefined, // pdb | pdt | pdr | pdl
      positionTool: "top",
      topElementPosition: 0,
    };
  },
  methods: {
    moveCellUp() {
      this.$store.dispatch("designIframe/component/moveCellUp", {
        id: this.cellActive.id,
        parent_id: this.gridActive.id,
      });

      this.$nextTick(() => {
        this.resetCellToolPosition();
      });
    },
    moveCellDown() {
      this.$store.dispatch("designIframe/component/moveCellDown", {
        id: this.cellActive.id,
        parent_id: this.gridActive.id,
      });
      this.$nextTick(() => {
        this.resetCellToolPosition();
      });
    },
    resetCellToolPosition() {  
      this.$store.dispatch("designIframe/frame/setSectionActive", {
        component_id: this.section_id,
        name: this.section_id,
      });    
      this.$store.dispatch("designIframe/frame/setCellActive", {
        component_id: this.cellActive.id,
        parent_id: this.gridActive.id,
      });
    },
    toggleEnableMobile() {
      this.component.properties.isEnableMobile =
        !this.component.properties.isEnableMobile;
      this.$store.dispatch("designIframe/snapshot/genSnapshot");
    },
    goTo(type) {
      switch (type) {
        case "section": {
          var compID = this.section_id;

          this.$store.dispatch("designIframe/frame/setSectionActive", {
            component_id: compID,
            name: compID,
          });
          this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
          this.$store.dispatch("designIframe/frame/setCellActive", {});
          this.$store.dispatch("designIframe/frame/setCellHover", {});
          this.$store.dispatch("designIframe/frame/setWidgetActive", {});
          this.$store.dispatch("designIframe/frame/setWidgetHover", {});
          this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
          this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
          this.$store.dispatch("designIframe/frame/setParentWidgetActive", {});
          let noneSetting = false;
          SECTION_TYPE_NONE_SETTING.find((type) => {
            Object.entries(this.components).forEach((item) => {
              if (type === item[1].type && item[1].id === this.section_id) {
                noneSetting = true;
              }
            })
          });
          if (noneSetting) {
            this.$store.dispatch("design/component/elActive", {});
          } else {
            this.$store.dispatch("design/component/elActive", {
              elementID: ["component", compID],
            });
          }
          break;
        }
        case "cell": {
          if (this.cellActive.id && this.gridActive.id) {
            this.$store.dispatch("designIframe/frame/setSectionActive", {
              component_id: this.section_id,
              name: this.section_id,
            });
            this.$store.dispatch("designIframe/component/elActive", {
              elementID: ["component", this.cellActive.id],
            });
            this.$store.dispatch("designIframe/frame/setCellActive", {
              component_id: this.cellActive.id,
              parent_id: this.gridActive.id,
            });
          }
          this.$store.dispatch("designIframe/frame/setSlideSectionHover", {});
          this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
          this.$store.dispatch("designIframe/frame/setSlideContainerHover", {})
          this.$store.dispatch("designIframe/frame/setSlideContainerActive", {})
          this.$store.dispatch("designIframe/frame/setWidgetHover", {})
          this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
          this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
          this.$store.dispatch("designIframe/frame/setSectionHover", {});
          this.$store.dispatch("designIframe/frame/setParentWidgetActive", {});
          break;
        }
        default:
          break;
      }
    },
  },
  watch: {
    scrollPosition() {
      this.$store.dispatch("designIframe/component/setComponentAction", {
        component_id: this.cellActive.id,
        type: "CELL",
        action: "ACTIVE",
      });
    },
    mode() {
      this.$nextTick(function () {
        this.$store.dispatch("designIframe/component/setComponentAction", {
          component_id: this.cellActive.id,
          type: "CELL",
          action: "ACTIVE",
        });
      });
    },
    cellActive: {
      deep: true,
      handler() {
        const element = document.getElementById("cell-active-frame")
        if(element) {
          this.$nextTick(() => {
            this.topElementPosition = element.offsetTop;
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      preview: "designIframe/preview",
      renderTools: "designIframe/frame/renderTools",
      widgetActive: "designIframe/frame/widgetActive",
      cellActive: "designIframe/frame/cellActive",
      gridActive: "designIframe/frame/gridActive",
      components: "designIframe/metadata/components",
      mode: "designIframe/mode",
      languageEngine: "designIframe/userPreference/languageEngine",
      scrollPosition: "scrollPosition",
      detectDevice: "detectDevice",
    }),
    component() {
      return this.components[this.cellActive.id] || {};
    },
    isEnableMobile() {
      if (!this.cellActive.id) {
        return false;
      }
      return !(
        this.component.properties.isEnableMobile != undefined &&
        this.component.properties.isEnableMobile == false
      );
    },
    isOverScroll() {
      const diff = this.scrollPosition - this.topElementPosition;
      if (diff >= 0) {
        return true;
      } else {
        return false;
      }
    },
    section_id() {
      return this.gridActive.id && Object.entries(this.components).filter(
        (item) =>
          item[1].componentsID &&
          item[1].componentsID.includes(this.gridActive.id)
      )[0][0];
    },
    indexCell() {
      if (this.components[this.gridActive.id]) {
        if (this.detectDevice == 'mobile') {
          return this.components[this.gridActive.id].componentsIDMobile.indexOf(this.cellActive.id);
        } else {
          return this.components[this.gridActive.id].componentsID.indexOf(this.cellActive.id);
        }
      } else {
        return 0;
      }
    },
    gridLayout() {
      if (this.components[this.gridActive.id]) {
        return this.components[this.gridActive.id].style.layout
      } else {
        return null
      }
    },
    isShowRehigh() {
      let totalWidth = 0;
      if (this.gridLayout) {
        Object.entries(gridLayoutConfig[this.gridLayout].cells).forEach(([key]) => {
          totalWidth += gridLayoutConfig[this.gridLayout].cells[key].width;
        })
      }
      return totalWidth > 100 || (this.detectDevice == 'mobile' && this.isEnableMobile) ? true : false;
    },
    sectionComponent() {
      return this.section_id && this.components[this.section_id]
    },
    gridMarginTop() {
      return (
        this.components[this.gridActive.id] &&
        this.components[this.gridActive.id].style.marginTop
      );
    },
    indexGrid() {
      return this.sectionComponent.componentsID.indexOf(this.gridActive.id);
    },
    isFirstIndex() {
      return this.indexGrid == 0;
    },
    isOverlap() {
      return this.sectionComponent && this.sectionComponent.style.width == 'container-fluid' && this.isFirstIndex && this.gridMarginTop == 0 && !this.widgetActive.id
    },
    layoutGridMobile() {
      return this.gridActive.id && this.components[this.gridActive.id].styleMobile.layout
    },
  },
};
</script>

<style lang="scss">
</style>